export default __webpack_public_path__ + "static/TSD_How_we_work_Resources-a4cc6ba49c7f027d1d7a01fabd3274a4.png";